import { useQuery, useQueryClient } from 'react-query';

import { fetchMyBundlePasses, fetchStoreBundlePassItems } from '@api/balloon';
import { PAYMENT_VENDOR, QUERY_KEYS } from '@constants';
import { VendorType } from '@model';
import { useMe } from '@utils/hook';

import { BROADCAST_CHANNEL, useBroadcastChannel } from './useBroadcastChannel';

export const useBundlePass = ({
  vendor = PAYMENT_VENDOR.standard,
}: {
  vendor: VendorType;
}) => {
  const { data: me } = useMe();
  const queryClient = useQueryClient();
  const myBundlePassQueryKey = QUERY_KEYS.PAYMENT.MY_BUNDLE_LIST();
  const bundlePassListQueryKey = QUERY_KEYS.PAYMENT.BUNDLE_LIST(vendor);

  useBroadcastChannel<string>(
    BROADCAST_CHANNEL.PURCHASE_DAILY_FREE_PASS,
    () => {
      queryClient.refetchQueries(myBundlePassQueryKey);
      queryClient.refetchQueries(bundlePassListQueryKey);
    }
  );

  const { data: myBundlePassList, refetch: refetchMyBundlePassList } = useQuery(
    myBundlePassQueryKey,
    () => fetchMyBundlePasses(),
    {
      enabled: !!me,
      onError: (err) => {
        console.log('err', err);
      },
    }
  );

  const { data: bundlePassList, refetch: refetchBundlePassList } = useQuery(
    bundlePassListQueryKey,
    () => fetchStoreBundlePassItems({ vendor }),
    {
      enabled: !!me,
    }
  );

  const isPurchaseDailyFreePass =
    (myBundlePassList &&
      myBundlePassList?.length > 0 &&
      myBundlePassList.some(
        (v) => v.bundlePassType === 'story_pass' && !v.isExpired
      )) ||
    false;

  const myDailyFreePass =
    (myBundlePassList &&
      myBundlePassList.find(
        (v) => v.bundlePassType === 'story_pass' && !v.isExpired
      )) ||
    null;

  const isShowDailyFreePassBanner =
    (bundlePassList &&
      bundlePassList?.some((v) => v.bundlePassType === 'story_pass')) ||
    false;

  return {
    myBundlePassList,
    refetchMyBundlePassList,
    bundlePassList,
    refetchBundlePassList,
    isPurchaseDailyFreePass,
    isShowDailyFreePassBanner,
    myDailyFreePass,
  };
};
